export default __webpack_public_path__ + "static/media/exam_skills.9073e17d.svg";